import axios from 'axios'
import router from './router'

import {
    Message,
    Loading
} from 'element-ui';
axios.defaults.withCredentials = true;
var domain = process.env.NODE_ENV === 'production' ? '' : 'http://exp.yunyiit.com'

//创建axios
var service = axios.create({
    baseURL: domain,
    headers: {
        'content-type': 'application/json',
    }
})

export default {
    domain: domain,
    //post请求
    post(url, param) {
        return new Promise((cback, reject) => {
            service({
                method: 'post',
                url,
                data: JSON.stringify(param)
            }).then(res => {
                var code = res.data.code.toString();
                if (code == 200) {
                    cback(res.data.data);
                } else if (code == 201) {
                    router.push('/');
                    reject(res.data);
                } else {
                    reject(res.data);
                    Message({
                        showClose: true,
                        message: res.data.msg,
                        type: 'error'
                    });
                }
            }).catch(err => {
                if (!err.response) {
                    Message({
                        showClose: true,
                        message: '请求错误',
                        type: 'error'
                    });
                    reject(err.response);
                } else {
                    reject(err.response);
                }
            })
        })
    },
}